import React, {Component} from 'react';
import {Grid, Loader, Message} from 'semantic-ui-react'
import {unsubscribeEmailsURL} from "../../shared/urls/clientapi";
import {callService, POST} from "../../shared/serviceInvoker";

export default class UnsubscribeEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unsubscribeSent: false,
      showLoader: true,
      error: false,
      unexpectedError: false,
    };
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params) {
      let username = this.props.match.params.username;

      if (username && username.trim()) {
        callService(
          POST,
          unsubscribeEmailsURL.replace('{username}', username),
          null,
          response => {
            this.setState({unsubscribeSent: true, showLoader: false});
          },
          error => {
            let error_status = false;
            if (error.response.status !== 404) {
              error_status = true;
            }
            this.setState({showLoader: false, unexpectedError: error_status});
          }
        );
      }
      else {
        this.setState({showLoader: false, error: true});
      }
    }
  }

  render() {
    const { showLoader, unsubscribeSent, error, unexpectedError } = this.state;
    let errorMsg;
    if (unexpectedError) {
      errorMsg = 'An unexpected error occurred while unsubscribing. Please try again later.'
    }
    else if (!error) {
      errorMsg = "The user you are trying to get unsubscribed can't be found.";
    }
    else {
      errorMsg = 'No user provided to unsubscribe.';
    }


    return (
      <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
        <Grid.Column style={{ maxWidth: 450 }}>
          <Loader active={showLoader} size='medium' style={{'margin-top': '40px'}}>
            Sending request to server ...
          </Loader>
          {
            unsubscribeSent && !showLoader ?
              <Message
                size='tiny'
                icon='checkmark'
                color='green'
                content='You have been successfully unsubscribed from future emails. Please allow a few days to take effect.'
              />
            :
              null
          }
          {
            !unsubscribeSent && !showLoader ?
              <Message
                size='tiny'
                icon='cancel'
                color='red'
                content={errorMsg}
              />
              :
              null
          }
        </Grid.Column>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UnsubscribeEmail/index.js